/*
  Adds the gift wrap from the cart drawer.

  Visibility is decided in Liquid — the drawer re-renders on every cart change,
  which takes this element with it — so all this has to do is post the add and
  hand the fresh sections to the theme, the same way the product upsell does.
*/

if (!customElements.get('cart-gift-wrap')) {
  class CartGiftWrap extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-gift-wrap-add]');
      this.button?.addEventListener('click', () => this.add());
    }

    async add() {
      const variantId = Number(this.dataset.variantId);
      if (!variantId || this.button.disabled) return;

      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: this.sections(),
          }),
        });

        const data = await response.json();
        if (!response.ok) throw data;

        this.announce(variantId, data);
      } catch (error) {
        console.error('Gift wrap could not be added', error);
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
      }
    }

    /* The sections the theme re-renders after any cart change. */
    sections() {
      const drawer = document.querySelector('cart-drawer');
      const ids = (drawer?.getSectionsToRender?.() || []).map((section) => section.section);
      return ids.length ? ids.join(',') : 'cart-drawer,cart-counter';
    }

    announce(variantId, data) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-gift-wrap',
          productVariantId: variantId,
          cartData: data,
        });
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        /* The drawer is already open — re-render without reopening it. */
        drawer.renderContents(data, false);
      }

      if (typeof updateCartCounters === 'function') updateCartCounters();
    }
  }

  customElements.define('cart-gift-wrap', CartGiftWrap);
}
